import React, { useEffect, useState } from 'react'
import boardService from '../services/boardService'
import Button from 'monday-ui-react-core/dist/Button'
import { Delete, Edit } from 'monday-ui-react-core/dist/allIcons'
import Dropdown from 'monday-ui-react-core/dist/Dropdown'
import { Checkbox, Toast } from 'monday-ui-react-core'
import PermissionAttentionBox from '../cmps/PermissionAttentionBox'

export default function Relation({ sessionToken, relation, boards, boardNames, userId, deleteRelation, isMulti, isLicenseExpired, monday }) {
  const [boardRelation, setBoardRelation] = useState({
    mainBoard: {
      board: { value: 0, label: '' },
      column: { value: '', label: '' },
      connectColumn: { value: '', label: '' },
      mainWebhook: null,
    },
    subBoards: relation.subBoards || [],
    userId,
    _id: relation._id,
  })
  const [mainBoardColumns, setMainBoardColumns] = useState()
  const [mainBoardConnectColumns, setMainBoardConnectColumns] = useState()
  const [buttonLoading, setButtonLoading] = useState(false)
  const [hasPermissions, setHasPermissions] = useState(false)
  const [currIsMulti, setCurrIsMulti] = useState(isMulti)


  const [countWebhook, setCountWebhook] = useState(0)

  useEffect(() => {
    addBoardsNames()
    getMainBoardColumns(relation?.mainBoard?.board?.value)
  }, [])

  const getMainBoardColumns = async (boardId) => {
    const query = `query{
      boards(ids:${boardId}){
        columns{
          type
          title
          id
        }
      }
    }`
    const res = await monday.api(query)
    const dropdowns = []
    const connectBoards = []
    let columnData = res.data.boards[0]?.columns?.forEach((column) => {
      if (column.type === 'dropdown') {
        dropdowns.push({ value: column.id, label: column.title })
      } else if (column.type === 'board-relation' || column.type === 'board_relation') {
        connectBoards.push({ value: column.id, label: column.title })
      }
    })
    setMainBoardColumns(dropdowns)
    setMainBoardConnectColumns(connectBoards)
  }

  const editRelation = async () => {
    try {
      setButtonLoading({ edit: true })
      relation.subBoards.forEach(async (existedSubBoard) => {
        const existsInBoardRelation = boardRelation.subBoards.some((newSubBoard) => newSubBoard.subBoard.value === existedSubBoard.subBoard)

        if (!existsInBoardRelation) {
          await boardService.deleteWebhooks(existedSubBoard.subWebhook)
          console.log(`Object with subBoard ${existedSubBoard.subBoard} exists in relation.subBoards but not in boardRelation.subBoards`)
        }
      })

      const subBoards = await Promise.all(
        boardRelation.subBoards.map(async (newSubBoard) => {
          const existsInRelation = relation.subBoards.some((existedSubBoard) => existedSubBoard.subBoard === newSubBoard.subBoard.value)

          // New webhook to add
          if (!existsInRelation) {
            const sub = await boardService.createMirrorWebHook(newSubBoard.subBoard.value, 'mirrorItemKR', relation.subBoards?.[0].event, 'subWebhook')
            console.log(`Object with subBoard ${newSubBoard.subBoard.value} exists in boardRelation.subBoards but not in relation.subBoards`)

            return {
              subBoard: Number(newSubBoard.subBoard.value || newSubBoard.subBoard),
              subWebhook: sub.subWebhook,
            }
          } else {
            // Copy existing data
            return {
              subBoard: Number(newSubBoard.subBoard.value || newSubBoard.subBoard),
              subWebhook: newSubBoard.subWebhook,
            }
          }
        })
      )
      // //replacing webhooks for main board
      if (!boardRelation.mainBoard.board.value !== relation.mainBoard.board.value) {
        await boardService.deleteWebhooks(relation.mainBoard.mainWebhook)
        if (relation.mainBoard.matchGroupAndItemNameWebHookId) await boardService.deleteWebhooks(relation.mainBoard.matchGroupAndItemNameWebHookId)
        boardRelation.mainBoard.mainWebhook = await boardService.createNewItemWebHook(boardRelation.mainBoard.board.value, boardRelation.mainBoard.column.value)
        boardRelation.mainBoard.matchGroupAndItemNameWebHookId = await boardService.matchGroupAndItemNameWebHook(Number(boardRelation.mainBoard.board.value))
      }

      const res = await boardService.update(boardRelation.mainBoard, subBoards, userId, boardRelation._id, relation.userDomain, currIsMulti, sessionToken)
      addBoardsNames(res)

      monday.execute('notice', {
        message: `Relation updated successfuly!`,
        type: 'success',
        timeout: 8000,
      })
    } catch (err) {
      monday.execute('notice', {
        message: `Error on update Relation`,
        type: 'error',
        timeout: 8000,
      })
      console.log('file: Relation.jsx:112 -> err:', err)
    } finally {
      setButtonLoading({ edit: false })
    }
  }

  const addBoardsNames = (object = relation) => {

    const tempRelation = {
      mainBoard: {
        board: { value: 0, label: '' },
        column: { value: '', label: '' },
        connectColumn: { value: '', label: '' },
        mainWebhook: null,
      },
      subBoards: [],
      _id: relation._id,
      userId: boardRelation.userId,
    }
    tempRelation.mainBoard = object.mainBoard
    // tempRelation.subBoards = object?.subBoards?.map(
    object?.subBoards?.forEach(({ subBoard, subWebhook }) => {
      const subBoardData = boards?.find(board => Number(board?.value) === subBoard)
      if(subBoardData) tempRelation.subBoards.push({ subBoard: subBoardData, subWebhook })
    })

    setBoardRelation(tempRelation)
  }

  const onSetRelation = (kind, newBoards) => {
    let newRelation = {
      userId: userId,
      mainBoard: boardRelation.mainBoard,
      subBoards: boardRelation.subBoards,
      _id: relation._id,
    }
    if (kind === 'sub') {
      const subs = newBoards?.map((newBoard) => {
        let thisSub = boardRelation.subBoards.find((sub) => sub.subBoard.value === newBoard.value)
        if (!thisSub) {
          return (thisSub = {
            subBoard: { value: newBoard.value, label: newBoard.label },
            subWebhook: null,
          })
        } else {
          return thisSub
        }
      })

      if (!subs) newRelation.subBoards = []
      else newRelation.subBoards = subs
    } else if (kind === 'main') {
      newRelation.mainBoard.board = newBoards
      newRelation.mainBoard.connectColumn = null
      newRelation.mainBoard.column = null
      newRelation.subBoards = []
      // newRelation.mainBoard.mainWebhook = null;
    } else if (kind === 'connect') {
      newRelation.mainBoard.connectColumn = newBoards
    } else if (kind === 'dropdown') {
      newRelation.mainBoard.column = newBoards
    }
    // return;
    setBoardRelation(newRelation)
    kind !== 'sub' && getMainBoardColumns(newRelation.mainBoard.board.value)
  }
  const subBoardsNames = boardRelation?.subBoards?.map((sub) => sub?.subBoard)
  const isDisableUpdate = !boardRelation.mainBoard?.board || !subBoardsNames?.length || !boardRelation.mainBoard?.column || !boardRelation.mainBoard?.connectColumn

  return (
    <>
      <Toast open={buttonLoading.delete && relation.subBoards.length > 0} type={Toast.types.NORMAL} onClose={() => setCountWebhook(0)} actions={[]}>
        <p>
          Deleting Sub Webhooks: {countWebhook} / {relation.subBoards.length} ...
        </p>
      </Toast>
      <div className="content">
        <div className="select-div">
          <span className="select-span">Main board</span>
          <Dropdown className="select" disabled={isLicenseExpired} placeholder="Choose a main board" value={boardRelation.mainBoard?.board} options={boardNames} onChange={(boards) => onSetRelation('main', boards)} />
        </div>
        <div className="select-div">
          <span className="select-span">Dropdown</span>
          <Dropdown className="select" disabled={!boardRelation.mainBoard?.board || isLicenseExpired} placeholder="Choose a dropdown" value={boardRelation.mainBoard?.column} options={mainBoardColumns} onChange={(boards) => onSetRelation('dropdown', boards)} />
        </div>
        <div className="select-div">
          <span className="select-span">
            Connect <wbr />
            Boards
          </span>
          <Dropdown className="select" disabled={!boardRelation.mainBoard?.board || isLicenseExpired} placeholder="Choose a connect boards column" value={boardRelation.mainBoard?.connectColumn} options={mainBoardConnectColumns} onChange={(boards) => onSetRelation('connect', boards)} />
        </div>
        <div className="select-div">
          <span className="select-span">Sub Boards</span>
          <Dropdown
            className="select"
            disabled={!boardRelation.mainBoard?.board || isLicenseExpired}
            multi
            placeholder="Choose sub boards"
            value={subBoardsNames}
            options={boardNames}
            onChange={(boards) => onSetRelation('sub', boards)}
          />
        </div>
        <div className="select-div">
          <span className="select-span">Mirror Trigger</span>
          <Dropdown
            className="select"
            readOnly
            value={relation.subBoards?.[0].event === "create_item" ? { label: "on item creation", value: "create_item" } : { label: "on item move to group", value: "item_moved_to_any_group" }}
          />
        </div>
        <div className="is-multi-checkbox">
          <Checkbox className='is-multi' label="Groups by {group} ➡ {item}" onChange={() => setCurrIsMulti((isMulti) => !isMulti)} checked={currIsMulti} />
        </div>
        <PermissionAttentionBox subBoards={subBoardsNames || []} setHasPermissions={setHasPermissions} />
        <div className="button-section">
          <Button disabled={isDisableUpdate || isLicenseExpired || !hasPermissions} size={Button.sizes.MEDIUM} color={Button.colors.POSITIVE} className="add-button" loading={buttonLoading.edit} onClick={editRelation} leftIcon={Edit}>
            Update
          </Button>
          <Button disabled={isLicenseExpired || !hasPermissions} size={Button.sizes.MEDIUM} kind={Button.kinds.SECONDARY} color={Button.colors.NEGATIVE} className="add-button" loading={buttonLoading.delete} onClick={() => deleteRelation(relation, setButtonLoading, setCountWebhook)} leftIcon={Delete}>
            Delete
          </Button>
        </div>
      </div>
    </>
  )
}
